// extracted by mini-css-extract-plugin
export default {"root":"KLNboM3PEwsxgKfgGuCw","icon":"E8J7Q4j1DqS8nCKrBB2L","error":"vcKb8z__E4cOEmT1lago","success":"tffqtaPhcGx3upHwz2w3","info":"mkssSQRclMkZRtd6swZC"};